var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono celular"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 19.4996,
    cy: 19.4996,
    r: 19.4996,
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3863 24.2981V10.7336C26.3863 9.22427 25.1618 7.99976 23.6525 7.99976H13.9418C12.4325 7.99976 11.208 9.22427 11.208 10.7336V24.2981H26.3863ZM18.7924 9.70838C19.248 9.70838 19.6182 10.0786 19.6182 10.5342C19.6182 10.9899 19.248 11.3601 18.7924 11.3601C18.3368 11.3601 17.9666 10.9899 17.9666 10.5342C17.9761 10.0691 18.3368 9.70838 18.7924 9.70838Z",
    fill: "#0885C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1992 25.9404V27.668C11.1992 29.1773 12.4237 30.4113 13.933 30.4113H23.6437C25.153 30.4113 26.3775 29.1868 26.3775 27.668V25.9404H11.1992ZM18.7931 28.8831C18.3375 28.8831 17.9673 28.5129 17.9673 28.0572C17.9673 27.6016 18.3375 27.2314 18.7931 27.2314C19.2487 27.2314 19.6189 27.6016 19.6189 28.0572C19.6189 28.5129 19.2487 28.8831 18.7931 28.8831Z",
    fill: "#0885C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelular);
export default __webpack_public_path__ + "static/media/celular.69127a6c93cd3b0618986d83676b1634.svg";
export { ForwardRef as ReactComponent };